var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTag = function SvgTag(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4649 13.8618L13.8683 20.4602C13.5231 20.8058 13.0548 21 12.5664 21C12.078 21 11.6097 20.8058 11.2645 20.4602L3 12.2027V3H12.2004L20.4649 11.2667C21.1784 11.9845 21.1784 13.144 20.4649 13.8618Z",
    stroke: "#0B072A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 9.5C9.44035 9.5 10 8.94035 10 8.25C10 7.55965 9.44035 7 8.75 7C8.05965 7 7.5 7.55965 7.5 8.25C7.5 8.94035 8.05965 9.5 8.75 9.5Z",
    fill: "#0B072A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTag);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjQ2NDkgMTMuODYxOEwxMy44NjgzIDIwLjQ2MDJDMTMuNTIzMSAyMC44MDU4IDEzLjA1NDggMjEgMTIuNTY2NCAyMUMxMi4wNzggMjEgMTEuNjA5NyAyMC44MDU4IDExLjI2NDUgMjAuNDYwMkwzIDEyLjIwMjdWM0gxMi4yMDA0TDIwLjQ2NDkgMTEuMjY2N0MyMS4xNzg0IDExLjk4NDUgMjEuMTc4NCAxMy4xNDQgMjAuNDY0OSAxMy44NjE4WiIgc3Ryb2tlPSIjMEIwNzJBIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguNzUgOS41QzkuNDQwMzUgOS41IDEwIDguOTQwMzUgMTAgOC4yNUMxMCA3LjU1OTY1IDkuNDQwMzUgNyA4Ljc1IDdDOC4wNTk2NSA3IDcuNSA3LjU1OTY1IDcuNSA4LjI1QzcuNSA4Ljk0MDM1IDguMDU5NjUgOS41IDguNzUgOS41WiIgZmlsbD0iIzBCMDcyQSIvPgo8L3N2Zz4K";